<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" :format="dateFormat" :placeholder="datePickerPlaceholder" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Filtered By" >
                                <select class="form-control" v-model="inputFilterBy">
                                    <option v-for="option in filterOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-success float-right ml-2"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateExcel">
                                Generate Report in Excel
                            </button>

                            <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                                Generate Report in PDF
                            </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
          return {
            spinning: false,
            inputSortBy: 'trans_id',
            inputGroupBy: '',
            inputFilterBy: 2,
            inputSite: [],
            inputDate: [moment().startOf('day'), moment().endOf('day')],
            sortOptions: [
                {key: 'trans_id', value: 'Trans #'},
                {key: 'document_date', value: 'Date Time'}
            ],
            groupOptions: [
                {key: '', value: '[Flat List]'},
                {key: 'user_id', value: 'Cashier'},
                {key: 'customer_id', value: 'Customer'}
            ],
            filterOptions: [
                {key: 0, value: '[All Members]'},
                {key: 1, value: '[Non-Members]'},
                {key: 2, value: '[All Customers]'}
            ],
            siteOptions: [],
            dateFormat: 'MM/DD/YYYY hh:mm A',
            datePickerPlaceholder: ['Start', 'End'],
            birSalesReports: [],
            site_type: 'ho',

            showSortInfo: 'asc',
            imagepath: '',
            excelFileName: "sales_reports.xls",
            excelHeaders: {
              "Date": "date",
              "ID No": "idNo",
              "Customer Name": "customerName",
              "SI / OR Number": "siOrNo",
              "Sales (inclusive of VAT)": "sales",
              "VAT Amount": "vatAmount",
              "VAT Exempt": "vatExempt",
              "Discount": "discount",
              "Net Sales": "netSales"
            },
            excelIsNonVatable: false,
            reportDescription: ''
          }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(component_x.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                component_x.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)


            let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
            if (logoSettings.length > 0) {
                let logo_img = logoSettings[0]["value"]
                this.imagepath = this.publicUrl + 'account_logos/' + logo_img
            }

            this.initializeExportExcel();
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'publicUrl']),
        },
        watch: {
          currentProfile() {
            this.initializeExportExcel();
          }
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            reportNumber(value){
              const number = Number(value)
              return isNaN(number) ? 0 : number
            },
            convertToCurrency(num){
              return this.reportNumber(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrencyForExcel(num){
              return this.reportNumber(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            isNonVatableReport(reportDetails){
              if(Array.isArray(reportDetails)){
                return reportDetails.length > 0 && String(reportDetails[0].company_vat_type || 'V') == 'N'
              }
              return reportDetails && String(reportDetails.company_vat_type || 'V') == 'N'
            },
            salesHeaderLabel(reportDetails){
              return this.isNonVatableReport(reportDetails) ? 'Sales' : 'Sales (inclusive of VAT)'
            },
            setExcelHeaders(isNonVatable){
              const idHeader = this.currentProfile == 'senior_citizen_sales_reports' ? 'SC ID No.' : 'PWD ID No.'
              const nameHeader = this.currentProfile == 'senior_citizen_sales_reports' ? 'Name of Senior Citizen' : 'Name of PWD'
              const headers = {
                "Terminal Name": "terminalName",
                "Cashier Name": "cashierName",
                "Date": "date",
                [idHeader]: "idNo",
                [nameHeader]: "customerName",
                "SI / OR Number": "siOrNo",
                [isNonVatable ? "Sales" : "Sales (inclusive of VAT)"]: "sales"
              }

              if(!isNonVatable){
                headers["VAT Amount"] = "vatAmount"
                headers["VAT Exempt"] = "vatExempt"
              }

              headers["Discount"] = "discount"
              headers["Net Sales"] = "netSales"
              this.excelHeaders = headers
            },
            bookHeaderColStyles(reportDetails){
              if(this.isNonVatableReport(reportDetails)){
                return {
                  0: {cellWidth: 35},
                  1: {cellWidth: 35},
                  2: {cellWidth: 65},
                  3: {cellWidth: 40},
                  4: {cellWidth: 40},
                  5: {cellWidth: 35},
                  6: {cellWidth: 35}
                }
              }

              return {
                0: {cellWidth: 35},
                1: {cellWidth: 35},
                2: {cellWidth: 55},
                3: {cellWidth: 35},
                4: {cellWidth: 35},
                5: {cellWidth: 35},
                6: {cellWidth: 35},
                7: {cellWidth: 30},
                8: {cellWidth: 30}
              }
            },
            bookDetailColStyles(reportDetails){
              if(this.isNonVatableReport(reportDetails)){
                return {
                  0: {cellWidth: 35},
                  1: {cellWidth: 35},
                  2: {cellWidth: 62},
                  3: {cellWidth: 40},
                  4: {cellWidth: 40},
                  5: {cellWidth: 35},
                  6: {cellWidth: 35}
                }
              }

              return {
                0: {cellWidth: 35},
                1: {cellWidth: 35},
                2: {cellWidth: 52},
                3: {cellWidth: 35},
                4: {cellWidth: 35},
                5: {cellWidth: 35},
                6: {cellWidth: 35},
                7: {cellWidth: 30},
                8: {cellWidth: 30}
              }
            },
            bookGroupColSpan(reportDetails){
              return this.isNonVatableReport(reportDetails) ? 6 : 8
            },
            bookHeaders(headerTable, headerCard, customerNameHeader, reportDetails){
              const detailHeaders = [
                {content: 'Date', styles: {halign: 'center'}},
                {content: headerCard, styles: {halign: 'center'}},
                {content: customerNameHeader, styles: {halign: 'center'}},
                {content: 'SI / OR\nNumber', styles: {halign: 'center'}},
                {content: this.salesHeaderLabel(reportDetails), styles: {halign: 'center'}}
              ]

              if(!this.isNonVatableReport(reportDetails)){
                detailHeaders.push(
                  {content: 'VAT Amount', styles: {halign: 'center'}},
                  {content: 'VAT Exempt\nSales', styles: {halign: 'center'}}
                )
              }

              detailHeaders.push(
                {content: 'Discount', styles: {halign: 'center'}},
                {content: 'Net Sales', styles: {halign: 'center'}}
              )

              return [
                [{content: headerTable, colSpan: detailHeaders.length, styles: {halign: 'center'}}],
                detailHeaders
              ]
            },
            bookDetailRow(reportLine, reportDetails){
              const netSales = this.reportNumber(reportLine.amount_wvat) - this.reportNumber(reportLine.discount_amount)
              const row = [
                {content: moment(reportLine.document_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                this.sanitizeCardNumber(reportLine.card_number),
                {content: reportLine.customer_name, styles: {halign: 'left'}},
                reportLine.invoice_no,
                this.convertToCurrency(reportLine.amount_wvat)
              ]

              if(!this.isNonVatableReport(reportDetails)){
                row.push(
                  this.convertToCurrency(reportLine.vat_amount),
                  this.convertToCurrency(reportLine.vat_exempt)
                )
              }

              row.push(this.convertToCurrency(reportLine.discount_amount), this.convertToCurrency(netSales))
              return row
            },
            bookTotalRow(label, amountWithVat, vatAmount, vatExempt, discountAmount, reportDetails){
              const netSales = this.reportNumber(amountWithVat) - this.reportNumber(discountAmount)
              const row = ['', '', '', label, this.convertToCurrency(amountWithVat)]

              if(!this.isNonVatableReport(reportDetails)){
                row.push(this.convertToCurrency(vatAmount), this.convertToCurrency(vatExempt))
              }

              row.push(this.convertToCurrency(discountAmount), this.convertToCurrency(netSales))
              return row
            },
            sanitizeCardNumber(cardNumber) {
              return String(cardNumber || '')
                .replace(/PWD#\s*/gi, '')
                .replace(/SC#\s*/gi, '')
                .trim()
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            initializeExportExcel() {
              if(this.currentProfile == 'senior_citizen_sales_reports'){
                this.excelFileName = `Senior_Citizen_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.xls`;
                this.setExcelHeaders(false)
              }else {
                this.excelFileName = `PWD_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.xls`;
                this.setExcelHeaders(false)
              }
            },
            excelData: async function() {
              this.spinning= true;
              let jsonData = [];
              let request = {};
              let total_sales = 0
              let total_vatAmount = 0
              let total_vatExempt = 0
              let total_discount = 0
              let total_netSales = 0

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning= false;
                    return
                }

              if(this.currentProfile == 'senior_citizen_sales_reports'){
                request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/senior_citizen_book?site_id=' + this.inputSite +
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                    '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null)
              }else {
                request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/pwd_book?site_id=' + this.inputSite +
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                    '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null)
              }

              if (!request[0]) {
                this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                this.spinning= false;
                return;
              }

              const reportDetails = request[0].report_details;
              const isNonVatable = this.isNonVatableReport(reportDetails)
              this.excelIsNonVatable = isNonVatable
              this.setExcelHeaders(isNonVatable)

              reportDetails.map(detail => {
                let netSales = Number(detail.amount_wvat) - Number(detail.discount_amount)
                total_sales += Number(detail.amount_wvat)
                total_vatAmount += Number(detail.vat_amount)
                total_vatExempt += Number(detail.vat_exempt)
                total_discount += Number(detail.discount_amount)
                total_netSales += netSales
                const row = {
                  terminalName: detail.terminal_name,
                  cashierName: detail.cashier_name,
                  date: moment(detail.document_date).format('MM/DD/YYYY'),
                  idNo: this.sanitizeCardNumber(detail.card_number),
                  customerName: detail.customer_name,
                  siOrNo: detail.invoice_no,
                  sales: Number(Number(detail.amount_wvat).toFixed(2)),
                  discount: Number(Number(detail.discount_amount).toFixed(2)),
                  netSales: Number(netSales.toFixed(2))
                }

                if(!isNonVatable){
                  row.vatAmount = Number(Number(detail.vat_amount).toFixed(2))
                  row.vatExempt = Number(Number(detail.vat_exempt).toFixed(2))
                }

                jsonData.push(row)
              })

              this.spinning= false;

              const totalRow = {
                  terminalName: '',
                  cashierName: '',
                  date: '',
                  idNo: '',
                  customerName: '',
                  siOrNo: 'Grand Total:',
                  sales: Number(total_sales.toFixed(2)),
                  discount: Number(total_discount.toFixed(2)),
                  netSales: Number(total_netSales.toFixed(2))
                }

              if(!isNonVatable){
                totalRow.vatAmount = Number(total_vatAmount.toFixed(2))
                totalRow.vatExempt = Number(total_vatExempt.toFixed(2))
              }

              jsonData.push(totalRow)

              return jsonData
            },
            generateExcel: async function() {
              const jsonData = await this.excelData()
              if(!jsonData || jsonData.length === 0) return

              const workbook = new ExcelJS.Workbook();
              workbook.created = new Date();
              workbook.modified = new Date();

              const sheetName = this.currentProfile == 'senior_citizen_sales_reports' ? 'SC Sales Book' : 'PWD Sales Book'
              const sheet = workbook.addWorksheet(sheetName, {
                pageSetup:{paperSize: 9}
              });

              const isNonVatable = this.excelIsNonVatable
              const idHeader = this.currentProfile == 'senior_citizen_sales_reports' ? 'SC ID No.' : 'PWD ID No.'
              const nameHeader = this.currentProfile == 'senior_citizen_sales_reports' ? 'Name of Senior Citizen' : 'Name of PWD'

              const headers = ['Terminal Name', 'Cashier Name', 'Date', idHeader, nameHeader, 'SI / OR Number']
              const keys = ['terminalName', 'cashierName', 'date', 'idNo', 'customerName', 'siOrNo']

              if(isNonVatable){
                headers.push('Sales')
                keys.push('sales')
              } else {
                headers.push('Sales (inclusive of VAT)', 'VAT Amount', 'VAT Exempt')
                keys.push('sales', 'vatAmount', 'vatExempt')
              }
              headers.push('Discount', 'Net Sales')
              keys.push('discount', 'netSales')

              sheet.getRow(1).values = headers
              sheet.getRow(1).font = { bold: true }

              // Set columns
              const columns = [
                { key: 'terminalName', width: 20 },
                { key: 'cashierName', width: 20 },
                { key: 'date', width: 15 },
                { key: 'idNo', width: 18 },
                { key: 'customerName', width: 25 },
                { key: 'siOrNo', width: 18 }
              ]

              if(isNonVatable){
                columns.push({ key: 'sales', width: 18 })
              } else {
                columns.push(
                  { key: 'sales', width: 18 },
                  { key: 'vatAmount', width: 15 },
                  { key: 'vatExempt', width: 15 }
                )
              }
              columns.push(
                { key: 'discount', width: 15 },
                { key: 'netSales', width: 18 }
              )
              sheet.columns = columns

              // Add data rows
              const rowDatas = jsonData.map(row => {
                const rowData = {}
                keys.forEach(key => {
                  rowData[key] = row[key] !== undefined ? row[key] : ''
                })
                return rowData
              })
              sheet.addRows(rowDatas)

              // Apply number format to amount columns
              const amountNumFmt = '#,##0.00'
              const amountStartCol = 7 // sales column (1-indexed)

              sheet.eachRow(function (Row, rowNum) {
                if(rowNum > 1){
                  Row.eachCell(function (Cell, colNumber) {
                    if(colNumber >= amountStartCol){
                      Cell.numFmt = amountNumFmt
                    }
                    Cell.alignment = { vertical: 'middle', horizontal: 'left' }
                  })
                } else {
                  Row.eachCell(function (Cell) {
                    Cell.alignment = { horizontal: 'center' }
                  })
                }
              })

              const fileName = this.currentProfile == 'senior_citizen_sales_reports'
                ? `Senior_Citizen_Sales_Book_${moment().format('YYYYMMDDHHmmss')}.xlsx`
                : `PWD_Sales_Book_${moment().format('YYYYMMDDHHmmss')}.xlsx`

              workbook.xlsx.writeBuffer().then(function(buffer) {
                const blob = new Blob([buffer], { type: "application/xlsx" });
                saveAs(blob, fileName);
              });
            },
            generateReport: async function () {

                this.spinning= true;
                var get_request = {}

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning= false;
                    return
                }

                let header_card = "SC ID No."
                let cust_name = "Name of Senior Citizen"
                let header_table = 'Senior Citizen Sales Book'
                if(this.currentProfile == 'senior_citizen_sales_reports'){
                    get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/senior_citizen_book?site_id=' + this.inputSite +
                        '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                        '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null)
                }else {
                    header_card = "PWD ID No."
                    cust_name = "Name of PWD"
                    header_table = 'PWD Sales Book'
                    get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/pwd_book?site_id=' + this.inputSite +
                        '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                        '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null)
                }
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                var siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    for(var x=0; x < siteSpecific.length; x++){
                        let design_x = 15
                        let design_y = 10

                        let headerColStyles = this.bookHeaderColStyles(siteSpecific[x].report_details)

                        let detailColStyles = this.bookDetailColStyles(siteSpecific[x].report_details)

                        let reportLogo = document.getElementById('reportLogo');
                        doc.addImage(reportLogo, "PNG", 15, 0, 20, 20);

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(siteSpecific[x].report_details[0].company_name, doc.internal.pageSize.width / 2, design_y, null, null, 'center');

                        design_y = design_y + 5
                        doc.text(siteSpecific[x].report_details[0].company_address, doc.internal.pageSize.width / 2, design_y, null, null, 'center');

                        design_y = design_y + 5
                        if(this.inputSite != undefined && this.inputSite.length == 1){
                            doc.text(siteSpecific[x].report_details[0].site_tin_branch_code, doc.internal.pageSize.width / 2, design_y, null, null, 'center');
                        } else {
                            doc.text(siteSpecific[x].report_details[0].company_tin, doc.internal.pageSize.width / 2, design_y, null, null, 'center');
                        }

                        doc.setFontSize(10);
                        doc.setFontType("normal");

                        this.birSalesReports = siteSpecific[x].report_details

                        let main_grouper = ''
                        let grouper = ''
                        let grouper_text = ''
                        if(this.birSalesReports.length > 0){
                            let reportData = []

                            let g_amount_wvat = 0
                            let g_vat_amount = 0
                            let g_vat_exempt = 0
                            let g_discount_amount = 0

                            let total_amount_wvat = 0
                            let total_vat_amount = 0
                            let total_vat_exempt = 0
                            let total_discount_amount = 0

                            for(var i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let detail = []

                                if(this.inputGroupBy == 'user_id'){
                                    if(grouper == ''){
                                        let detail_header = ["Cashier: ", {content: reportLine.cashier_name, colSpan: this.bookGroupColSpan(this.birSalesReports), styles: {halign: 'left'}}]
                                        reportData.push(detail_header)
                                    } else {
                                        if(grouper != reportLine.user_id){
                                            let detail_header = ["Cashier: ", {content: reportLine.cashier_name , colSpan: this.bookGroupColSpan(this.birSalesReports), styles: {halign: 'left'}}]
                                            reportData.push(detail_header)
                                        }
                                    }
                                    grouper = reportLine.user_id
                                }else if(this.inputGroupBy == 'customer_id'){
                                    if(grouper == '' && grouper_text == ''){
                                        let detail_header = ["Customer :", {content: reportLine.customer_name , colSpan: this.bookGroupColSpan(this.birSalesReports), styles: {halign: 'left'}}]
                                        reportData.push(detail_header)
                                    } else {
                                    if(grouper != reportLine.customer_id){
                                            let detail_header = ["Customer :", {content: reportLine.customer_name , colSpan: this.bookGroupColSpan(this.birSalesReports), styles: {halign: 'left'}}]
                                            reportData.push(detail_header)
                                        } else {
                                            if(reportLine.customer_id == 0){
                                                let current_grouper = reportLine.customer_name
                                                let prev_grouper = this.birSalesReports[i-1].customer_name
                                                if(current_grouper != prev_grouper){
                                                    let detail_header = ["Customer :", {content: reportLine.customer_name , colSpan: this.bookGroupColSpan(this.birSalesReports), styles: {halign: 'left'}}]
                                                    reportData.push(detail_header)
                                                }
                                            }
                                        }
                                    }

                                    grouper = reportLine.customer_id
                                    grouper_text = reportLine.customer_name
                                }

                                //set table rows
                                detail = this.bookDetailRow(reportLine, this.birSalesReports)
                                reportData.push(detail)

                                g_amount_wvat += Number(reportLine.amount_wvat)
                                g_vat_amount += Number(reportLine.vat_amount)
                                g_vat_exempt += Number(reportLine.vat_exempt)
                                g_discount_amount += Number(reportLine.discount_amount)

                                total_amount_wvat += Number(reportLine.amount_wvat)
                                total_vat_amount += Number(reportLine.vat_amount)
                                total_vat_exempt += Number(reportLine.vat_exempt)
                                total_discount_amount += Number(reportLine.discount_amount)

                                if(main_grouper == ''){
                                    design_y = design_y + 10
                                    doc.text(design_x, design_y, "Software")
                                    doc.text(design_x+50, design_y, "Barter POS Version 5.0")

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "Serial Number")
                                    doc.text(design_x+50, design_y, reportLine.serial_number)

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "Machine Number")
                                    doc.text(design_x+50, design_y, reportLine.machine_number)

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "POS Terminal Number")
                                    doc.text(design_x+50, design_y, reportLine.terminal_name)

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "Date Generated")
                                    doc.text(design_x+50, design_y, `${moment().format('MM/DD/YYYY hh:mm a')}`)

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "User")
                                    doc.text(design_x+50, design_y, secureStorage.getItem("email"))

                                    design_y = design_y + 5
                                    let headers = this.bookHeaders(header_table, header_card, cust_name, this.birSalesReports)

                                    doc.autoTable({
                                        startY: design_y,
                                        head: headers,
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: headerColStyles
                                    });
                                } else {
                                    if(main_grouper != reportLine.terminal_id){

                                        //if new terminal display prev terminal details
                                        design_y = design_y + 15

                                        if(this.inputGroupBy != ''){
                                            let total = this.bookTotalRow('Total :', total_amount_wvat, total_vat_amount, total_vat_exempt, total_discount_amount, this.birSalesReports)
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, total))

                                            total_amount_wvat = 0
                                            total_vat_amount = 0
                                            total_vat_exempt = 0
                                            total_discount_amount = 0
                                        }

                                        let grand = this.bookTotalRow('Grand Total :', g_amount_wvat, g_vat_amount, g_vat_exempt, g_discount_amount, this.birSalesReports)
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, grand))

                                        g_amount_wvat = 0
                                        g_vat_amount = 0
                                        g_vat_exempt = 0
                                        g_discount_amount = 0

                                        grouper = ''
                                        grouper_text = ''

                                        doc.autoTable({
                                            startY: design_y,
                                            body: reportData,
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: detailColStyles,
                                            didParseCell: function(data) {
                                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                    data.cell.styles.fillColor = [0, 0, 0]
                                                    data.cell.styles.fontSize = 1
                                                    data.cell.styles.cellPadding = 0
                                                } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[3] == 'Total :')){
                                                    data.cell.styles.fontStyle = 'bold'
                                                }
                                            }
                                        });
                                        reportData = []

                                        //add new page
                                        doc.addPage();

                                        design_x = 15
                                        design_y = 15

                                        doc.text(design_x, design_y, "Software")
                                        doc.text(design_x+50, design_y, "Barter POS Version 5.0")

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "Serial Number")
                                        doc.text(design_x+50, design_y, reportLine.serial_number)

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "Machine Number")
                                        doc.text(design_x+50, design_y, reportLine.machine_number)

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "POS Terminal Number")
                                        doc.text(design_x+50, design_y, reportLine.terminal_name)

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "Date Generated")
                                        doc.text(design_x+50, design_y, `${moment().format('MM/DD/YYYY hh:mm a')}`)

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "User")
                                        doc.text(design_x+50, design_y, secureStorage.getItem("email"))
                                        let headers = this.bookHeaders(header_table, header_card, cust_name, this.birSalesReports)

                                        design_y = design_y + 5
                                        doc.autoTable({
                                            startY: design_y,
                                            head: headers,
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            headStyles: {
                                                lineWidth: 0.15
                                            },
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: headerColStyles
                                        });
                                    } else {
                                        if(i != this.birSalesReports.length-1){
                                            let current_grouper = ""
                                            let next_grouper = ""

                                            if(this.inputGroupBy == 'user_id'){
                                                current_grouper = reportLine.user_id
                                                next_grouper = this.birSalesReports[i+1].user_id
                                            } else if(this.inputGroupBy == 'customer_id'){
                                                if(reportLine.customer_id == 0){
                                                    current_grouper = reportLine.customer_name
                                                    next_grouper = this.birSalesReports[i+1].customer_name
                                                } else {
                                                    current_grouper = reportLine.customer_id
                                                    next_grouper = this.birSalesReports[i+1].customer_id
                                                }
                                            }

                                            if(current_grouper != next_grouper){
                                                if(this.inputGroupBy != ''){
                                                    let total = this.bookTotalRow('Total :', total_amount_wvat, total_vat_amount, total_vat_exempt, total_discount_amount, this.birSalesReports)
                                                    reportData.push(Object.assign({}, ["rowLine"]))
                                                    reportData.push(Object.assign({}, total))

                                                    total_amount_wvat = 0
                                                    total_vat_amount = 0
                                                    total_vat_exempt = 0
                                                    total_discount_amount = 0
                                                }
                                            }
                                        }
                                    }
                                }
                                main_grouper = reportLine.terminal_id

                                if(i == this.birSalesReports.length-1){
                                    //last record display terminal details
                                    design_y = design_y + 15

                                    if(this.inputGroupBy != ''){
                                        let total = this.bookTotalRow('Total :', total_amount_wvat, total_vat_amount, total_vat_exempt, total_discount_amount, this.birSalesReports)
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, total))
                                    }

                                    let grand = this.bookTotalRow('Grand Total :', g_amount_wvat, g_vat_amount, g_vat_exempt, g_discount_amount, this.birSalesReports)
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, grand))

                                    doc.autoTable({
                                        startY: design_y,
                                        body: reportData,
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[3] == 'Total :') ){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    for(i = 0; i < pageCount; i++) {
                        doc.setPage(i);
                        doc.text(340,210,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            }
        }
    };
</script>

<style></style>
